export default defineNuxtPlugin(() => {
    return {
        provide: {
            loadNanoPlayer: () => {
                if (typeof window !== 'undefined' && !window.NanoPlayer) {
                    return new Promise((resolve, reject) => {
                        const script = document.createElement('script')
                        script.type = 'text/javascript'
                        script.src = '/assets/js/nanoplayer.4.min.js'
                        script.onload = () => resolve(window.NanoPlayer)
                        script.onerror = reject
                        document.head.appendChild(script)
                    })
                }
            },
        },
    }
})
